import React from 'react'
import flash from "../../../assets/img/icons/flash 2.svg"
const PlaceReserve = () => {
  return (
    <div className='PlaceReserve'>
        <img src={flash} />
       <div>
       <p className='text-[#12171C] text-[20px] font-[700] '>رزرو آنی و فوری</p>
       <p className='text-[#51555A] text-[18px] font-[600] mt-[4px]'>برای رزرو نهایی این اقامتگاه نیازی به تایید از سمت میزبان نخواهید داشت و رزرو شما قطعی خواهد بود.</p>
       </div>
        
    </div>
  )
}

export default PlaceReserve